


















import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import NativeVideo from './ProductNativeVideo.vue';
import VimeoVideo from './ProductVimeoVideo.vue';
import YoutubeVideo from './ProductYoutubeVideo.vue';
import { supportedSizes, VideoType } from './constants';
import breakpointState from '@/core/responsive/breakpoints/breakpointsState.observable';
import { XS } from '@/core/config/breakpointConfig';

@Component({
    components: { NativeVideo, VimeoVideo, YoutubeVideo }
})

export default class ProductVideoRender extends Vue {
    @Prop({ type: String, required: true })
    private videoUrl!: string;

    @Prop({
        required: true,
        type: String
    }) mode!: 'thumbnail' | 'pdp' | 'fullscreen';

    @Prop({
        type: [String, Object],
        required: true,
        validator: (value: string | object) => {
            const valuesToCheck = typeof value === 'string' ? [value] : Object.values(value);
            return valuesToCheck.every(val => supportedSizes.includes(val));
        }
    })
    private size!: string | { [breakpoint: string]: string};

    private get videoType(): VideoType {
        let videoType: VideoType;

        if (this.videoUrl.indexOf(VideoType.Vimeo) !== -1) {
            videoType = VideoType.Vimeo;
        } else if (this.videoUrl.indexOf(VideoType.Youtube) !== -1) {
            videoType = VideoType.Youtube;
        } else {
            videoType = VideoType.Native;
        }

        return videoType;
    }

    private get isYoutubeVideo() {
        return this.videoType === VideoType.Youtube;
    }

    private get isVimeoVideo() {
        return this.videoType === VideoType.Vimeo;
    }

    private get screenMode(): string {
        if (this.isMobile) return 'fullscreen';

        switch (this.mode) {
        case 'thumbnail':
            return 'thumbnail';
        case 'pdp':
            return 'pdp';
        case 'fullscreen':
            return 'fullscreen';
        }
        throw new Error('unknown screen-mode: ' + this.mode);
    }

    protected get isMobile() {
        return breakpointState.isBreakpointActive(XS);
    }

    private get cssClasses(): string {
        return `${this.screenMode} ${this.videoType}`;
    }

    private get iconWidth(): string {
        return this.screenMode === 'thumbnail' ? '13' : '26';
    }

    private get iconHeight(): string {
        return this.screenMode === 'thumbnail' ? '16' : '32';
    }

    private get allowControls() {
        return this.screenMode === 'fullscreen' || this.isMobile;
    }

    $refs!: Vue['$refs'] & {
        videoWrapper: HTMLElement
    }

    private autoplay: boolean | null = false;

    private mounted() {
        const videoWrapper = this.$refs.videoWrapper;
        const visibleState = this.isScrolledIntoView(videoWrapper);
        this.autoplay = visibleState;
    }

    private isScrolledIntoView(el: HTMLElement) {
        const parent = el.closest('.swiper-container');
        if (!parent) return false;
        const rect = el.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const isVisible = (rect.top >= parentRect.top) && (rect.bottom <= parentRect.bottom) && (rect.left >= parentRect.left) && (rect.right <= parentRect.right);
        return isVisible;
    }

    private get startVideo() {
        return this.screenMode === 'fullscreen' && this.autoplay;
    }
}
